import { render, staticRenderFns } from "./printBillStyleTwo.vue?vue&type=template&id=2bdedc24&scoped=true&"
import script from "./printBillStyleTwo.vue?vue&type=script&lang=js&"
export * from "./printBillStyleTwo.vue?vue&type=script&lang=js&"
import style0 from "./printBillStyleTwo.vue?vue&type=style&index=0&id=2bdedc24&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdedc24",
  null
  
)

export default component.exports